import React, { useState } from 'react'
import { useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux'
import { Button, Checkbox, IcoAdd, IcoBin, IcoPencil, IcoUpload, List, LoadingContent, IcoQrcode  } from '../../../../components';
import { useEffect } from 'react';
import { listarGruposProdutos, listarMeusProjetosEmpresas, listarMeusProjetosProdutos, listarSubsegmentos, removeListMeuProjetoTab, removerProduto } from '../../redux/meusProjetosActions';
import { modalOpen, AddAlert } from '../../../../layout/redux/layoutActions';
import Add from './add';
import Importar from './importar';
import Grupos from './grupos';
import { IF, filterList, history } from '../../../../helpers';
import { typeStatusCustom } from '../../redux/meusProjetos';
import ObterMais from '../../obterMais';
import { modalAlertaInfo, modalClose, modalAlertaClean, informeNaoMostrar } from '../../../../layout/redux/layoutActions'
import { PopoverCentralAjuda } from '../../../../components/popovercentralajuda/popovercentralajuda'
import { editarProduto, criarProduto } from '../../redux/meusProjetosActions';
import AdquirirAtivos from '../../../minhasAssinaturas/content/adquirirAtivos';
import QrcodeAmazon from './QrcodeAmazon';


export default () => {
  const dispatch = useDispatch()
  const {idProjetos, idPasso} = useParams()
  const location = useLocation();
  const { sistema, usuario } = useSelector(state => state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)

  const nlsContexto = require(`../../../centralAjuda/nlscontexto/${sistema.idioma}.json`)

  const idarray = [128];
  const idarray1 = [129];
  const idarray2 = [130];

  
  const { meuProjeto, paginate } = useSelector(state=> state.meusProjetosState)
  const [form, setForm] = useState({selects: {}})
  const [infomodal, setInfomodal] = useState({selects: {}})
  const [produtos, setProdutos] = useState([])

  const [urlQrcodeAmazon, setUrlQrcodeAmazon] = useState(null);
  const [nomeProdutoQrcode, setNomeProdutoQrcode] = useState('');
  const [qrcodeTitle, setQrcodeTitle] = useState('');


  const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)
  const datarenovacao = sistema.dataAtualizacaoAssinatura

  const formatarDataRenovacao = (data, idioma) => {
    // Mapeia o idioma 'esp' para 'es-ES' para compatibilidade com Intl.DateTimeFormat
    if (!data) {
      //console.log("DATA NÃO É NO FORMATO VÁLIDO")
      return "";
    }
    //console.log("DATA é VÁLIDO1!!!")
    const locale = idioma === "esp" ? "es-ES" : idioma;
    //console.log("DATA é VÁLIDO2!!!")
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date(data));
  };

    const datarenovacaoformatada = formatarDataRenovacao(datarenovacao, sistema.idioma);




  useEffect(()=> {
    console.warn(meuProjeto, idProjetos, 'meuProjeto');
    if (idProjetos) {
      
      dispatch(listarMeusProjetosEmpresas({idProjeto: idProjetos}))
      dispatch(listarMeusProjetosProdutos({...meuProjeto.produtosPaginate, idProjeto: idProjetos}))
      dispatch(listarGruposProdutos(idProjetos))
      // dispatch(listarSubsegmentos({ProjetoId: idProjetos, SegmentoId: ''}))
    }
  }, [idProjetos])

  useEffect(()=> {
    if (meuProjeto?.projeto?.segmentoId) {
      dispatch(listarSubsegmentos({SegmentoId: meuProjeto.projeto.segmentoId}))
    }
  }, [meuProjeto.projeto])

    useEffect(()=> {
      const query = new URLSearchParams(location.search);
      const searchTerm = query.get('produtos');
      if (meuProjeto?.produtos?.length && searchTerm) {
        setProdutos(filterList(searchTerm, 'nomeProduto', meuProjeto.produtos))
      } else {
        setProdutos(meuProjeto?.produtos)
      }
    }, [meuProjeto.produtos, history.location])

  const headerDefault = [
    {
      column: 'checkboxCustom',
      text: <Checkbox 
        name='all'
        checked={form.selects?.all}
        action={e=> handleCheckboxSelect({name: 'all', value: e.value})}
      />,
      className: 'actions',
    },
    {
      column: 'nomeProduto',
      text: nls.table.nome,
      className: '',
    },
    {
      column: 'statusCuston',
      text: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {nls.table.status}
          <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray} />
        </div>
      ),
      sort: '',
      className: '',
    },
    {
      column: 'nomeEmpresa',
      text: nls.table.empresa,
      sort: '',
      className: '',
    },
    {
      column: 'subSegmento',
      text: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {nls.table.subsegmento}
          <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray1} />
        </div>
      ),
      sort: '',
      className: '',
    },
    {
      column: 'grupoCustom',
      text: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {nls.table.grupo}
          <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray2} />
        </div>
      ),
      className: '',
    },
    {
      column: 'urlAmazonCustom',
      text: 'Amazon',
      className: '',
    },
    {
      column: 'actions',
      text: '',
      className: 'actions',
    }
  ]

  const handleCheckboxSelect = e => {
    if (e.name === 'all') {
      let all = {all: e.value}
      meuProjeto.produtos.filter(f=> f.situacao !== 'AD').map(p=> {  all = {...all, [p.idProduto]: e.value} })
      setForm({...form, selects: all})
    } else {
      setForm({...form, selects: {...form.selects, [e.name]: e.value}})
    }
  }

  const selectedHas = Object.keys(form.selects).filter(p=> form.selects[p] ).length

  const handlePaginate = e => {
    console.warn(e, 'handlePaginate');
    
    dispatch(listarMeusProjetosProdutos({...meuProjeto.produtosPaginate, idProjeto: idProjetos, pageNumber: e}))
  }

  const handlePerPage = e => {
    console.warn(e, 'handlePerPage');
    
    dispatch(listarMeusProjetosProdutos({...meuProjeto.produtosPaginate, idProjeto: idProjetos, perPage: Number(e.value.id)}))
  }
  
  const handleAddModal = e => {
    if (e?.idProduto) {
      setInfomodal(e); // Dados para edição
      dispatch(modalOpen('criarProdutoMeuProjeto')); // Abre o modal de criação
    } else if (sistema?.creditoConta?.creditoProdutos) {
      setInfomodal({}); // Limpa o estado para um novo produto
      dispatch(modalOpen('criarProdutoMeuProjeto')); // Abre o modal de criação
    } else {
      dispatch(modalOpen('obter-mais')); // Popup de créditos insuficientes
    }
  };

    const handleConfirmCreate = formValues  => {
      dispatch(
        modalAlertaInfo({
          ...nlsPopup[16], // Conteúdo do popup
          show: true,
          btnAction: () => {
            
            dispatch(criarProduto({ ...formValues, projetoId: idProjetos, nlsPopup }));
            dispatch(modalAlertaClean());
            dispatch(modalClose()); // Fecha o modal de confirmação
          },
        })
      );
    };

  
  
  const handleRemove = e => {
    const returnedHas = Object.keys(e).filter(f=> f !== 'all' && e[f] === true).map(f=> Number(f))
    dispatch(removerProduto(returnedHas, idProjetos, nlsPopup))
    handleCheckboxSelect({name: 'all', value: false})
    dispatch(modalAlertaClean())
  }

  const handleImportarModal = e => {
    if (sistema?.creditoConta?.creditoProdutos) {
      dispatch(modalOpen('importarProdutoMeuProjeto'))
    } else {
      dispatch(modalOpen('obter-mais'))
    }
    dispatch(modalAlertaClean())
  }

  const handleGruposModal = e => {
    dispatch(modalOpen('gruposProdutoMeuProjeto'))
  }
  

  const handleUpgradeCredito = e => {
    if (usuario?.permissoes?.VerFazerUpgrade) {
      dispatch(modalClose())
      history.push('/upgradeconta')
    } else if (usuario?.permissoes?.VerMinhasAssinaturas) {
      dispatch(modalOpen('assinaturas-adquirir-ativos'))
    }
  }


  return (
    <div className='box-meus-projetos-produtos'>
      <div className='box-meus-projetos-topinfo'>
        <h5>{nls.title}</h5>
        <div>
          <Button
            type='link'
            color='default'
            onClick={() =>
              dispatch(
                modalAlertaInfo({
                  ...nlsPopup[12], // Inclui o conteúdo de nlsPopup[12]
                  show: true, // Garante que o modal será exibido
                  btnAction: () => handleRemove(form.selects), // Define a ação no botão de confirmação
                  textos: {
                    DataRenovacaoAssinatura: datarenovacaoformatada, // Adiciona informações personalizadas
                  },
                })
              )
            }
            disabled={selectedHas === 0? true:false}
          ><IcoBin /> {nls.btnExcluir}</Button>
          <Button
            color='primary'
            onClick={()=> handleGruposModal()}
          >{nls.btnGrupos}</Button>
            <Button
              color='default'
              onClick={()=> handleImportarModal()}
            ><IcoUpload /> {nls.btnImportar}</Button>
            <Button
              color='primary circle'
              onClick={() => handleAddModal()}
  
            ><IcoAdd /> {nls.btnAdd}</Button>
        </div>
      </div>
      {console.error(produtos, 'produtos')}
      <LoadingContent
          show={false}
        >
          <List
            header={headerDefault}
            data={produtos}
            listCustom={e=> {
              const item = e

              const statusInfo = typeStatusCustom(e.statusProduto)
              //item.statusCuston = <span style={{cursor: 'pointer'}} className={statusInfo?.class}>{e.statusProduto}</span>
              item.statusCuston = <span>{e.statusProduto}</span>; // Apenas texto
              
              // e.status?nls.ativo:nls.inativo

              item.grupoCustom = e.grupoProduto
              item.urlAmazonCustom = `${e.urlAmazonProduto.slice(0, 100)}${e.urlAmazonProduto.length>100?'...':''}`

              //QRCODE AMAZON
              if ((e.situacao === "A" || e.situacao === "AI") && typeof item.urlAmazonCustom === 'string') {
                const match = e.urlAmazonProduto.match(/\/dp\/([A-Z0-9]{10})|pd_rd_i=([A-Z0-9]{10})/);
                const asin = match ? (match[1] || match[2]) : null;

                // Aqui você calcula o domínio da url da amazon cadastrada no produto
                let dominioAmazon = 'https://www.amazon.com.br';
                try {
                  const parsedUrl = new URL(e.urlAmazonProduto);
                  dominioAmazon = `${parsedUrl.protocol}//${parsedUrl.hostname}`;
                } catch (err) {
                  console.error('URL inválida da amazon para gerar qrcode:', e.urlAmazonProduto);
                }

              
                item.urlAmazonCustom = (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    {item.urlAmazonCustom}
                    {asin && (
                      <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          const qrUrl = `${dominioAmazon}/review/create-review/?ie=UTF8&channel=glance-detail&asin=${asin}`;
                          setUrlQrcodeAmazon(qrUrl);
                          setNomeProdutoQrcode(`${e.nomeProduto}`);
                          setQrcodeTitle('Amazon Qrcode Download');
                          dispatch(modalOpen('qrcode-amazon'));
                        }}
                      >
                        <IcoQrcode style={{ width: 16, height: 16 }} />
                      </span>
                    )}
                  </div>
                );
              }


              item.checkboxCustom = e.situacao !== 'AD'? <>
                <Checkbox 
                  name={e.idProduto}
                  checked={form.selects?.[e.idProduto]}
                  action={c=> handleCheckboxSelect({name: e.idProduto, value: c.value})}
                />
              </> :null
              item.actions = true? <>
                <Button
                  type='link'
                  color='default'
                  onClick={()=> handleAddModal(e)}
                ><IcoPencil /> {nls.btnEditar}</Button>
              </> :null

              return item
            }}
            paginate={meuProjeto.produtosPaginate}
            actionPaginate={(e)=> handlePaginate(e)}
            handlePerPage={(e)=> handlePerPage(e)}
            nls={nls.paginacao}
          />
        </LoadingContent>
        <Add data={infomodal} onConfirmCreate={handleConfirmCreate} />
        <Importar />
        <Grupos />
        <ObterMais type='conteudoProdutos'
          actions={
            <Button
              type='btn'
              color='primary'
              size='block'
              variant='outlined'
              onClick={()=> handleUpgradeCredito()}
              disabled={usuario.perfil?.id === 2 ? true : false}
              title={usuario.perfil?.id === 2 ? nls.obterMais.naoPodeAdquirir : nls.obterMais.podeAdquirir}
            >{nls.obterMais.textobotaoadquirir}</Button>
          }
        />
        <QrcodeAmazon
          url={urlQrcodeAmazon}
          nomeItem={nomeProdutoQrcode}
          title={qrcodeTitle}
          texto={nls.qrcodetexto}
          textoSemUrl={nls.qrcodetextosemurl}
        />
        <AdquirirAtivos/>

    </div>
  )
}
